import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';


const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { loadModalCollectionByLink } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();

  const handleClose = () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  const handleSubmit = async () => {
    await onSubmit();
  };

  const handleContinue = async () => {
    if (resource.meta().canPost()) {
      return handleSubmit();
    }
    return handleClose();
  };

  return (
    <>
      <MetaControlField
        attr={'primaryText'}
        {...dataAttrs('risk-tolerance-title', resource, {
          [testAttr.dataType]: resource.attr('type'),
        })}
      />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={2}>
          <MetaControlField attr={'tertiaryText'} />
          <MetaControlField attr={'secondaryText'} />
          <MetaControlField attr={'clients'} />
          <MetaControlField attr={'resultHelpText'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        <FDPrimaryActionButton
          loading={saving}
          label={'Continue →'}
          onClick={handleContinue}
          {...dataAttrs('continue-btn', resource, {
            [testAttr.dataType]: resource.attr('type'),
          })}
        />
      </DialogActions>
    </>
  );
};

export default Layout;
